//= require intersection-observer/intersection-observer.js

$(function() {
  'use strict';

  var $backgrounds = $('.js-intersection-background');
  var $foregrounds = $('.js-intersection-foreground');

  // Early exit
  if(!$backgrounds.length) return;
  if(!$foregrounds.length) return;

  var buildThresholdList = function (numSteps) {
    var thresholds = [];

    for (var i=1.0; i<=numSteps; i++) {
      var ratio = i/numSteps;
      thresholds.push(ratio);
    }

    thresholds.push(0);
    return thresholds;
  };

  var handleIntersect = function (entries, observer) {
    for(var i=0; i < entries.length; i++) {
      var entry = entries[i];
      var color = $(entry.target).attr('data-color');
      $foregrounds.each(function(index, foreground) {
        var $foreground = $(foreground);
        var center = $foreground.position().top + $foreground.outerHeight() / 2;
        if(entry.boundingClientRect.top < center && entry.boundingClientRect.bottom > center ) {
          $foreground.addClass('u-color-' + color);
        } else {
          $foreground.removeClass('u-color-' + color);
        }
      });
    }
  };

  var options = {
    threshold: buildThresholdList(100)
  };

  var observer = new IntersectionObserver(handleIntersect, options);

  $backgrounds.each(function (index, background) {
    observer.observe(background);
  });

});
